// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileObjectsList_elements__K01gM {
  width: 100%;
  padding: 0 20px;
}
.ProfileObjectsList_elements__K01gM a {
  color: inherit;
  text-decoration: none;
  font-weight: normal;
}
.ProfileObjectsList_elements__K01gM ul {
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 0;
}
.ProfileObjectsList_elements__K01gM ul li,
.ProfileObjectsList_elements__K01gM ul input {
  background-color: rgb(218, 218, 218);
  padding: 10px 20px;
  display: flex;
  border-radius: 23px;
  height: -moz-fit-content;
  height: fit-content;
}
.ProfileObjectsList_elements__K01gM ul li {
  margin: 5px;
  flex-direction: column;
}
.ProfileObjectsList_elements__K01gM ul li .ProfileObjectsList_name__HaBiF .ProfileObjectsList_add-image-button__q3ZHe {
  padding: 1px 3px;
  border: none;
  background-color: transparent;
  margin-left: 15px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
}
.ProfileObjectsList_elements__K01gM ul li .ProfileObjectsList_name__HaBiF .ProfileObjectsList_add-image-button__q3ZHe svg {
  width: 16px;
  height: 16px;
  fill: rgb(100, 100, 100);
}
.ProfileObjectsList_elements__K01gM ul li .ProfileObjectsList_name__HaBiF .ProfileObjectsList_add-image-button__q3ZHe svg:hover {
  fill: rgb(80, 80, 80);
}
.ProfileObjectsList_elements__K01gM ul li > a {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.ProfileObjectsList_elements__K01gM ul input {
  height: 46px;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  border: 2px solid rgb(138, 175, 221);
  background-color: rgb(240, 240, 240);
}
.ProfileObjectsList_elements__K01gM ul > span {
  display: flex;
  flex-direction: row;
}
.ProfileObjectsList_elements__K01gM ul > span > .ProfileObjectsList_delete-object-button__TA09L {
  margin-right: 15px;
  background-color: transparent;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  height: 46px;
  align-self: flex-start;
}
.ProfileObjectsList_elements__K01gM ul > span > .ProfileObjectsList_delete-object-button__TA09L:hover {
  background-color: rgba(0, 0, 0, 0.0666666667);
}
.ProfileObjectsList_elements__K01gM ul > span > .ProfileObjectsList_delete-object-button__TA09L:active {
  background-color: rgba(0, 0, 0, 0.1333333333);
}
.ProfileObjectsList_elements__K01gM ul > span > .ProfileObjectsList_delete-object-button__TA09L svg {
  fill: grey;
}`, "",{"version":3,"sources":["webpack://./src/Components/ProfileObjectsList/ProfileObjectsList.module.scss"],"names":[],"mappings":"AAAA;EACG,WAAA;EACA,eAAA;AACH;AACG;EACG,cAAA;EACA,qBAAA;EACA,mBAAA;AACN;AAEG;EACG,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AAAN;AAEM;;EAEG,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;AAAT;AAGM;EACG,WAAA;EACA,sBAAA;AADT;AAKY;EACG,gBAAA;EACA,YAAA;EACA,6BAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,mBAAA;AAHf;AAKe;EACG,WAAA;EACA,YAAA;EACA,wBAAA;AAHlB;AAKkB;EACG,qBAAA;AAHrB;AAUM;EACG,uBAAA;EACA,mBAAA;EACA,gBAAA;AART;AAWM;EACG,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,oCAAA;EACA,oCAAA;AATT;AAYM;EACG,aAAA;EACA,mBAAA;AAVT;AAYS;EACG,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;AAVZ;AAYY;EACG,6CAAA;AAVf;AAaY;EACG,6CAAA;AAXf;AAcY;EACG,UAAA;AAZf","sourcesContent":[".elements {\n   width: 100%;\n   padding: 0 20px;\n\n   a {\n      color: inherit;\n      text-decoration: none;\n      font-weight: normal;\n   }\n\n   ul {\n      list-style: none;\n      display: flex;\n      flex-direction: row;\n      flex-wrap: wrap;\n      padding: 10px 0;\n\n      li,\n      input {\n         background-color: rgb(218, 218, 218);\n         padding: 10px 20px;\n         display: flex;\n         border-radius: 23px;\n         height: fit-content;\n      }\n\n      li {\n         margin: 5px;\n         flex-direction: column;\n\n         .name {\n\n            .add-image-button {\n               padding: 1px 3px;\n               border: none;\n               background-color: transparent;\n               margin-left: 15px;\n               display: inline-flex;\n               flex-direction: row;\n               align-items: center;\n\n               svg {\n                  width: 16px;\n                  height: 16px;\n                  fill: rgb(100, 100, 100);\n\n                  &:hover {\n                     fill: rgb(80, 80, 80);\n                  }\n               }\n            }\n         }\n      }\n\n      li>a {\n         text-overflow: ellipsis;\n         white-space: nowrap;\n         overflow: hidden;\n      }\n\n      input {\n         height: 46px;\n         align-items: center;\n         justify-content: flex-start;\n         flex-direction: row;\n         border: 2px solid rgb(138, 175, 221);\n         background-color: rgb(240, 240, 240);\n      }\n\n      >span {\n         display: flex;\n         flex-direction: row;\n\n         >.delete-object-button {\n            margin-right: 15px;\n            background-color: transparent;\n            border: none;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            padding: 5px;\n            height: 46px;\n            align-self: flex-start;\n\n            &:hover {\n               background-color: #0001;\n            }\n\n            &:active {\n               background-color: #0002;\n            }\n\n            svg {\n               fill: grey;\n            }\n         }\n      }\n   }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"elements": `ProfileObjectsList_elements__K01gM`,
	"name": `ProfileObjectsList_name__HaBiF`,
	"add-image-button": `ProfileObjectsList_add-image-button__q3ZHe`,
	"delete-object-button": `ProfileObjectsList_delete-object-button__TA09L`
};
export default ___CSS_LOADER_EXPORT___;
